import { render } from "./simpleArticle.vue?vue&type=template&id=1b23f298&scoped=true"
import script from "./simpleArticle.vue?vue&type=script&lang=js"
export * from "./simpleArticle.vue?vue&type=script&lang=js"

import "./simpleArticle.vue?vue&type=style&index=0&id=1b23f298&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b23f298"]])

export default __exports__